let categoriesScript = {
    init: function () {
        let $triggerButton = $('.js-toggle-categories')
        let $menuCategories = $('.categories-menu')
        $triggerButton.on('click', function () {
            if ($(window).width() >= 1200) {
                return
            }
            $menuCategories.slideToggle()
            $triggerButton.toggleClass('is-open')
        })
    },
}

categoriesScript.init()
